module.exports = __webpack_public_path__ + "static/img/genre_02.74f653a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/genre_02.png
// module id = HmhC
// module chunks = 0